/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://gis.clark.wa.gov/portal/jsapi/jsapi4/esri/copyright.txt for details.
*/
import{ZEROS as o}from"../../../../core/libs/gl-matrix-2/factories/vec4f64.js";const r=1.2,t=o,c=4;export{c as labelMarginPx,r as suspendResumeExtentOptimism,t as transparentUnit};
